module.exports = __webpack_public_path__ + "img/1440.aaf49990.jpg";